// Core
import React from "react";

// Instruments
import experience from "../theme/assets/data/experience.json";

// Components
import SectionHeading from "./SectionHeading";
import Workplace from "./Workplace";

export default class Experience extends React.Component {
    render () {
        const workplaceList = experience.map((workplace) => {
            return (
                <Workplace
                    company = { workplace.company }
                    key = { workplace.id }
                    location = { workplace.location }
                    period = { workplace.period }
                    position = { workplace.position }
                />
            );
        });

        return (
            <section>
                <SectionHeading number = '02.' title = 'Опыт работы' />

                {workplaceList}
            </section>
        );
    }
}
